export default {
  title: 'Nouveau prix',
  fields: {
    product: {
      label: 'Produit',
    },
    is_not_personal: {
      label: 'Visible par tous',
    },
    is_default: {
      label: 'Par défaut',
    },
    visible_to: {
      label: 'Visible par',
    },
  },
  buttons: {
    select_all: 'Tout sélectionner',
    save: 'Enregistrer',
    cancel: 'Annuler',
  },
  feedback: {
    missing_info: 'Informations manquantes',
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des données',
    price_got_created: 'Prix créé',
    price_got_updated: 'Prix mis à jour',
  },
};
